"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var Draftail = __importStar(require("draftail"));
var index_1 = __importStar(require("../../components/Draftail/index"));
/**
 * Entry point loaded when the Draftail editor is in use.
 */
// Expose Draftail package as a global.
window.Draftail = Draftail;
// Expose module as a global.
window.draftail = index_1["default"];
// Plugins for the built-in entities.
var plugins = [
    {
        type: 'DOCUMENT',
        source: index_1["default"].ModalWorkflowSource,
        decorator: index_1.Document,
    },
    {
        type: 'LINK',
        source: index_1["default"].ModalWorkflowSource,
        decorator: index_1.Link,
    },
    {
        type: 'IMAGE',
        source: index_1["default"].ModalWorkflowSource,
        block: index_1.ImageBlock,
    },
    {
        type: 'EMBED',
        source: index_1["default"].ModalWorkflowSource,
        block: index_1.EmbedBlock,
    },
];
plugins.forEach(index_1["default"].registerPlugin);
